export const makeConfigUrls = (topicId?: number) => {
  const options = topicId ? { topic_id: topicId } : undefined;

  return {
    // urls routing
    ...(topicId ? topicUrls(topicId) : networkUrls()),
    // api
    getCategoriesPath: () => Routes.categories_forums_discussions_path(options), // GET categories
    getDiscussionsPath: () => Routes.forums_discussions_path(options), // GET index
    createDiscussionPath: () => Routes.forums_discussions_path(options), // POST create
    getDiscussionPath: (discussionId: number) =>
      Routes.forums_discussion_path(discussionId, options), // GET detail
    getEditDiscussionPath: (discussionId: number) =>
      Routes.edit_forums_discussion_path(discussionId, options), // GET edit
    updateDiscussionPath: (discussionId: number) =>
      Routes.forums_discussion_path(discussionId, options), // PUT update
    deleteDiscussionPath: (discussionId: number) =>
      Routes.forums_discussion_path(discussionId, options), // DELETE
    followDiscussionPath: (discussionId: number) =>
      Routes.forums_discussion_toggle_follow_path(discussionId, options),
    getDiscussionSummaryPath: (discussionId: number) =>
      Routes.forums_discussion_summary_path(discussionId, options),
    getWidgetsPath: () => Routes.top_categories_forums_discussions_path(),
  };
};

const networkUrls = () => ({
  indexUrl: () => Routes.forum_path(),
  discussionUrl: (discussionId: number) =>
    Routes.forum_thread_path(discussionId),
  editDiscussionUrl: (discussionId: number) =>
    Routes.forum_edit_thread_path(discussionId),
  newDiscussionUrl: () => Routes.forum_new_thread_path(),
});

const topicUrls = (topicId: number) => ({
  indexUrl: () => Routes.topic_forum_index_path(topicId),
  discussionUrl: (discussionId: number) =>
    Routes.show_topic_forum_thread_path(topicId, discussionId),
  editDiscussionUrl: (discussionId: number) =>
    Routes.topic_forum_edit_thread_path(topicId, discussionId),
  newDiscussionUrl: () => Routes.topic_forum_new_thread_path(topicId),
});
